import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Comments|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

export type SPCandidateCommentListLocNames =
	| 'SPCandidateCommentListFieldLabelDate'
	| 'SPCandidateCommentListFieldLabelType'
	| 'SPCandidateCommentListFieldLabelUser'
	| 'SPCandidateCommentListFieldLabelComment'
	| 'SPCandidateCommentListNoComments';

export const spCandidateCommentListLocs: LocDefs<SPCandidateCommentListLocNames> = {
	SPCandidateCommentListFieldLabelDate: {
		defaultValue: 'Date',
		description: 'Label for: Date.',
		displayPath: `${pathStart}Date`,
		displayType: 'Label',
		legacyName: 'Core/Candidates.Comments.FieldLabel.DateField',
		...sharedProperties,
	},
	SPCandidateCommentListFieldLabelType: {
		defaultValue: 'Type',
		description: 'Label for: Type.',
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Core/Candidates.Comments.FieldLabel.TypeField',
		...sharedProperties,
	},
	SPCandidateCommentListFieldLabelUser: {
		defaultValue: 'User',
		description: 'Label for: User.',
		displayPath: `${pathStart}User`,
		displayType: 'Label',
		legacyName: 'Core/Candidates.Comments.FieldLabel.UserField',
		...sharedProperties,
	},
	SPCandidateCommentListFieldLabelComment: {
		defaultValue: 'Comment',
		description: 'Label for: Comment.',
		displayPath: `${pathStart}Comment`,
		displayType: 'Label',
		legacyName: 'Core/Candidates.Comments.FieldLabel.CommentField',
		...sharedProperties,
	},
	SPCandidateCommentListNoComments: {
		defaultValue: 'No comments available',
		description: 'Content shown when there are no comments',
		displayPath: `${pathStart}Content shown when there are no comments`,
		displayType: 'Content',
		legacyName: 'Core/Candidates.Comments.Content.NoComments',
		...sharedProperties,
	},
};

export const spCandidateCommentListLocKeys = MapLocKeys<SPCandidateCommentListLocNames>(
	spCandidateCommentListLocs
);

export type SPCandidateCommentListLocType = LocMap<SPCandidateCommentListLocNames>;
